import React, { useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  Dimensions,
  FlatList,
} from "react-native";
const { width, height } = Dimensions.get("window");

export default function page2({ getReport }) {
  function parseAmount(value) {
    const normalized = String(value ?? "0").replace(/,/g, "").trim();
    const parsed = Number(normalized);

    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getTotalPrice() {
    return getReport.reduce((sum, item) => sum + parseAmount(item?.amount), 0);
  }

  function getTotalPriceAfterVat() {
    const number = getTotalPrice();
    return number - number * 0.07;
  }

  return (
    <View style={styles.back}>
      <FlatList
        data={getReport}
        scrollEnabled={false}
        renderItem={({ index, item }) => {
          return (
            <View>
              {index == 0 && (
                <View style={styles.head}>
                  <View style={[styles.viewhead, { width: width * 0.07 }]}>
                    <Text style={styles.textadd}>ลำดับ</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.248 }]}>
                    <Text style={styles.textadd}>
                      ชื่อ/ที่อยู่ในการออกใบเสร็จรับเงิน
                    </Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.23 }]}>
                    <Text style={styles.textadd}>ราคาก่อนVat</Text>
                  </View>
                  <View style={[styles.viewhead, { width: width * 0.138 }]}>
                    <Text style={styles.textadd}>Vat%</Text>
                  </View>
                  <View style={[styles.viewheadent, { width: width * 0.138 }]}>
                    <Text style={styles.textadd}>รวมชำระ</Text>
                  </View>
                </View>
              )}
              <View
                style={[
                  styles.head,
                  { borderTopColor: "#fff" },
                  { backgroundColor: "#fff" },
                ]}
              >
                <View style={[styles.viewhead, { height: 160, width: width * 0.07 }]}>
                  <Text style={styles.textadd}>{index + 1}</Text>
                </View>
                <View style={[styles.viewhead, { height: 160, width: width * 0.248 }]}>
                  <Text style={styles.textadd}>
                    {item?.eventUser ? ((item?.eventUser?.fullAddress?.name ?? item?.eventUser?.user_accounts?.name ?? item?.eventUser?.user_accounts?.email ?? '') +
                      "\nsize: " +
                      (item?.eventUser?.fullAddress?.size ?? 'ไม่ระบุ') +
                      "\n" +
                      (item?.eventUser?.fullAddress?.ShippingAddress ?? '') +
                      " " +
                      (item?.eventUser?.fullAddress?.district ?? '') +
                      " " +
                      (item?.eventUser?.fullAddress?.postcode ?? '') +
                      " " +
                      (item?.eventUser?.fullAddress?.province ?? '') +
                      " " +
                      (item?.eventUser?.fullAddress?.subDistrict ?? '') +
                      " " +
                      (item?.eventUser?.fullAddress?.telnum ?? '') +
                      " \nสาขา " +
                      (item?.eventUser?.tag ?? '')) : item.description ?? "ไม่พบข้อมูล"}
                  </Text>
                </View>
                <View style={[styles.viewhead, { height: 160, width: width * 0.23 }]}>
                  <Text style={styles.textadd}>
                    {item.amount}
                  </Text>
                </View>
                <View style={[styles.viewhead, { height: 160, width: width * 0.138 }]}>
                  <Text style={styles.textadd}>{7}</Text>
                </View>
                <View style={[styles.viewheadent, { height: 160, width: width * 0.138 }]}>
                  <Text style={styles.textadd}>
                    {(parseAmount(item?.amount) - parseAmount(item?.amount) * 0.07).toFixed(2)}
                  </Text>
                </View>
              </View>
            </View>
          );
        }}
      />
      <View style={[styles.detailend, { backgroundColor: "#fff" }]}>
        <View
          style={[
            styles.viewheadsum,
            { width: width * 0.218 },
            { borderColor: "#fff" },
          ]}
        ></View>
        <View style={[styles.viewheadsum, { width: width * 0.1 }]}>
          <Text style={styles.textadd}>รวม</Text>
        </View>
        <View style={[styles.viewheadsum, { width: width * 0.23 }]}>
          <Text style={styles.textadd}>{getTotalPrice()}</Text>
        </View>
        <View style={[styles.viewheadsum, { width: width * 0.138 }]}>
          <Text style={styles.textadd}>{7}</Text>
        </View>
        <View style={[styles.viewheadsumend, { width: width * 0.1365 }]}>
          <Text style={styles.textadd}>{getTotalPriceAfterVat()?.toFixed(2)}</Text>
        </View>
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: width * 0.825,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    zIndex: -99
  },
  head: {
    width: width * 0.8224,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderWidth: 0.5,
    borderColor: "#666666",
  },
  detail: {
    width: width * 0.825,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    borderLeftWidth: 0.5,
    borderRightWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#666666",
  },
  detailend: {
    width: width * 0.825,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    borderRightWidth: 0.5,
    borderColor: "#666666",
    justifyContent: "center",
    paddingHorizontal: 10,
    height: 50,
  },
  viewheadsum: {
    borderLeftWidth: 0.5,
    borderBottomWidth: 0.5,
    borderColor: "#666666",
    justifyContent: "center",
    paddingHorizontal: 10,
    height: 50,
  },
  viewheadsumend: {
    borderLeftWidth: 0.5,
    borderBottomWidth: 0.5,
    borderRightWidth: 0.5,
    borderColor: "#666666",
    justifyContent: "center",
    paddingHorizontal: 10,
    height: 50,
  },
  viewheadent: {
    justifyContent: "center",
  },
  viewlow: {
    flexDirection: "row",
    width: width * 0.17,
    justifyContent: "space-between",
    alignSelf: "center",
    borderBottomWidth: 0.5,
    borderColor: "#666666",
    height: 50,
    paddingHorizontal: 10,
  },
  viewlowent: {
    flexDirection: "row",
    width: width * 0.17,
    justifyContent: "space-between",
    alignSelf: "center",
    height: 50,
    paddingHorizontal: 10,
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginVertical: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#172B4D",
    alignSelf: "center",
  },
  input: {
    width: width * 0.1,
    height: 30,
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#666666",
    paddingLeft: 20,
    alignSelf: "center",
  },
  touctto: {
    width: width * 0.1,
    height: 30,
    backgroundColor: "#4B4B48",
    borderRadius: 5,
    justifyContent: "center",
    alignSelf: "center",
  },
});
